<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-carga">Trámites</router-link> >
            <router-link :to="'/tramiteform-carga/' + this.p_idTramite"
              >Trámite {{ p_idTramite }}</router-link
            >
            > Carga {{ p_idCarga }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Numero</th>
          <th scope="col">Cedula</th>
          <th scope="col">Nombre</th>
          <th scope="col">Diag1</th>
          <th scope="col">Diag2</th>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Especialidad</th>
          <th scope="col">Errores</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cargaplanilla in datosPaginados"
          :key="cargaplanilla.idCargaPlanilla"
          @dblclick="handleRowClick($event, cargaplanilla.idCargaPlanilla)"
        >
          <td>{{ cargaplanilla.numero }}</td>
          <td>{{ cargaplanilla.cedula }}</td>
          <td>{{ cargaplanilla.nombre }}</td>
          <td>{{ cargaplanilla.diag1 }}</td>
          <td>{{ cargaplanilla.diag2 }}</td>
          <td>
            {{ getFormattedDate(cargaplanilla.fechaDesde, "DD/MM/YYYY") }}
          </td>
          <td>
            {{ getFormattedDate(cargaplanilla.fechaHasta, "DD/MM/YYYY") }}
          </td>
          <td>{{ cargaplanilla.especialidadNombre }}</td>
          <td
            :class="{
              'bg-danger text-white text-center':
                cargaplanilla.detalleErrores &&
                cargaplanilla.detalleErrores.length > 0,
            }"
          >
            {{
              cargaplanilla.detalleErrores &&
              cargaplanilla.detalleErrores.length > 0
                ? "SI"
                : "NO"
            }}
          </td>
          <td>
            <select
              class="form-select form-select-sm"
              @change="handleAction($event, cargaplanilla.idCargaPlanilla)"
            >
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Resumen</option>
              <option value="detalles">Detalles</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-center">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="irPrimeraPagina"
          >
            <a class="page-link" href="#">«</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="getPreviousPage"
          >
            <a class="page-link" href="#">‹</a>
          </li>

          <li class="page-item active">
            <a class="page-link" href="#">{{ paginaActual }}</a>
          </li>

          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="getNextPage"
          >
            <a class="page-link" href="#">›</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="irUltimaPagina"
          >
            <a class="page-link" href="#">»</a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Identificación -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-1">
                    <label class="form-label fw-bold">Id. Reg.</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext">
                      {{ datoCargaPlanilla.idCargaPlanilla }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Número</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext text-uppercase">
                      {{ datoCargaPlanilla.numero }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Especialidad</label>
                  </div>
                  <div class="col-5">
                    <p class="form-control-plaintext">
                      {{
                        especialidads.find(
                          (e) =>
                            e.idEspecialidad ===
                            datoCargaPlanilla.idEspecialidad
                        )?.nombre
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Datos Personales -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label class="form-label fw-bold">Cédula</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext text-uppercase">
                      {{ datoCargaPlanilla.cedula }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-8">
                    <p class="form-control-plaintext text-uppercase">
                      {{ datoCargaPlanilla.nombre }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Diagnósticos -->
              <div class="mb-3">
                <div class="row">
                  <div
                    class="col"
                    v-for="(label, index) in [
                      'Diagnóstico 01',
                      'Diagnóstico 02',
                      'Diagnóstico 03',
                      'Diagnóstico 04',
                      'Diagnóstico 05',
                    ]"
                    :key="index"
                  >
                    <label class="form-label fw-bold">{{ label }}</label>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col"
                    v-for="(diagnostico, index) in [
                      datoCargaPlanilla.diag1,
                      datoCargaPlanilla.diag2,
                      datoCargaPlanilla.diag3,
                      datoCargaPlanilla.diag4,
                      datoCargaPlanilla.diag5,
                    ]"
                    :key="index"
                  >
                    <p class="form-control-plaintext text-uppercase">
                      {{ diagnostico }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Fechas y Horas -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label class="form-label fw-bold">Fecha Desde</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext">
                      {{ datoCargaPlanilla.fechaDesde }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Fecha Hasta</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext">
                      {{ datoCargaPlanilla.fechaHasta }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Hora Desde</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext">
                      {{ datoCargaPlanilla.horaDesde }}
                    </p>
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Hora Hasta</label>
                  </div>
                  <div class="col-2">
                    <p class="form-control-plaintext">
                      {{ datoCargaPlanilla.horaHasta }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Detalle Errores -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label class="form-label fw-bold">Detalle Errores</label>
                    <p v-html="datoCargaPlanilla.detalleErrores"></p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      cargaplanillas: [],
      datoCargaPlanilla: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      cargas: [],
      especialidads: [],
      tramites: [],
      p_idTramite: 0,
      p_idCarga: 0,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idCarga = this.$route.params.p_idcarga;
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    handleRowClick(event, idCargaPlanilla) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditar(idCargaPlanilla);
    },
    handleAction(event, idCargaPlanilla) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idCargaPlanilla);
      } else if (action === "detalles") {
        this.abrirEditar(idCargaPlanilla);
      }
      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargaplanillas.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwcargaplanillas/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.cargaplanillas = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargaplanillas.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargaplanillas/idtramite-idcarga/" +
            this.p_idTramite +
            "/" +
            this.p_idCarga
        )
        .then((response) => {
          this.cargaplanillas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargaplanillas.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    irPrimeraPagina() {
      this.paginaActual = 1;
      this.getDataPaginaTodos(this.paginaActual);
    },
    irUltimaPagina() {
      this.paginaActual = this.totalPaginas();
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    abrirModalEditar(idCargaPlanilla) {
      this.modalWindow = true;
      if (idCargaPlanilla != null) {
        api.get("/vwcargaplanillas/" + idCargaPlanilla
          )
          .then((resp) => {
            this.datoCargaPlanilla = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idCargaPlanilla) {
      if (idCargaPlanilla != null) {
        this.$router.push("/cargaplanilla_cargaplanilladet/" + idCargaPlanilla);
      }
    },
  },
};
</script>
